/**
 * PaginationBar - numbered pagination bar for grids and results.
 * Custom element: <pagination-bar>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class PaginationBar extends ThemeComponent {
  init() {}
}
setFunctionName(PaginationBar, "PaginationBar");
const propertyTypes = {};
PaginationBar.prototype.$name = "PaginationBar";
PaginationBar.prototype.$info = JSON.parse('{"name":"PaginationBar","meta":{"isLegacy":false,"selector":"pagination-bar"},"props":[],"refs":[]}');
PaginationBar.prototype.$info.component = PaginationBar;
for (const prop of PaginationBar.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Pagination/PaginationBar.ts", {
  PaginationBar: PaginationBar
}, void 0);